import { Injectable } from "@angular/core";
import {
  AngularFirestore,
  AngularFirestoreCollection,
  CollectionReference,
  Query,
} from "@angular/fire/firestore";

import * as firebase from "firebase/app";
import "firebase/firestore";
import * as _ from "lodash";

import { environment } from "../../environments/environment";
import { User } from "../@core/data/users";
import { UserService } from "../@core/services/user.service";
import { ProductInventory } from "../models/product.model";

@Injectable({
  providedIn: "root",
})
export class ProductInventoryService {
  visibility = environment.visibility;
  userLogin: User;
  private dbPath = "/shops";

  collRef: AngularFirestoreCollection<ProductInventory>;

  constructor(
    private db: AngularFirestore,
    private userStore: UserService,
  ) {
    this.userStore.getCurrentUser().subscribe((user: User) => {
      if (user) {
        this.userLogin = user;
        this.visibility = user.companyId
          ? user.companyId
          : environment.visibility;
      }
    });
  }

  getProductInventories(
    shopId: string,
    productId: string,
    limitRecords?: number,
  ) {
    var db = firebase.default.firestore();
    var ref = db
      .collection(this.dbPath + `/${shopId}/product-inventories`)
      .where("isDeleted", "==", false)
      .where("isActive", "==", true)
      .where("productId", "==", productId)
      .orderBy("issueDate", "asc");

    if (limitRecords && limitRecords > 0) {
      ref = ref.limit(limitRecords);
    }

    return ref.get();
  }

  getAllInventoriesByProduct(shopId: string, productId: string) {
    var db = firebase.default.firestore();
    var ref = db
      .collection(this.dbPath + `/${shopId}/product-inventories`)
      .where("isDeleted", "==", false)
      .where("isActive", "==", true)
      .where("productId", "==", productId)
      .orderBy("issueDate", "asc");

    return ref.get();
  }

  getProductInventoriesByIssueDate(
    shopId: string,
    productId: string,
    fromDate: Date,
    toDate: Date,
    limitRecords?: number,
  ) {
    var db = firebase.default.firestore();
    var ref = db
      .collection(this.dbPath + `/${shopId}/product-inventories`)
      .where("isDeleted", "==", false)
      .where("isActive", "==", true)
      .where("productId", "==", productId)
      .where("issueDate", ">=", fromDate)
      .where("issueDate", "<=", toDate)
      .orderBy("issueDate", "asc");

    if (limitRecords && limitRecords > 0) {
      ref = ref.limit(limitRecords);
    }

    return ref.get();
  }

  // getProductInventoriesByIssueDate(
  //   shopId: string,
  //   productId: string,
  //   fromDate: Date,
  //   toDate: Date
  // ): AngularFirestoreCollection<ProductInventory> {
  //   return this.db.collection(
  //     this.dbPath + `/${shopId}/product-inventories`,
  //     (ref) =>
  //       ref
  //         .where("isDeleted", "==", false)
  //         .where("isActive", "==", true)
  //         .where("productId", "==", productId)
  //         .where("issueDate", ">=", fromDate)
  //         .where("issueDate", "<=", toDate)
  //         .orderBy("issueDate", "asc")
  //   );
  // }

  getProductInventoriesByMode(
    shopId: string,
    productId: string,
    isReceive: boolean,
  ): AngularFirestoreCollection<ProductInventory> {
    return this.db.collection(
      this.dbPath + `/${shopId}/product-inventories`,
      (ref) =>
        ref
          .where("isDeleted", "==", false)
          .where("isActive", "==", true)
          .where("productId", "==", productId)
          .where("isReceive", "==", isReceive)
          .orderBy("issueDate", "desc"),
    );
  }

  getProductInventoriesByTrade(
    shopId: string,
    productId: string,
    isReceive: boolean,
    supplierId?: string,
    customerId?: string,
  ): AngularFirestoreCollection<ProductInventory> {
    supplierId = isReceive ? supplierId : "";
    customerId = !isReceive ? customerId : "";
    console.log("getProductInventoriesByTrade/customerId:", customerId);
    console.log("getProductInventoriesByTrade/supplierId:", supplierId);
    console.log("getProductInventoriesByTrade/productId:", productId);

    return this.db.collection(
      this.dbPath + `/${shopId}/product-inventories`,
      (ref) =>
        ref
          .where("isDeleted", "==", false)
          .where("isActive", "==", true)
          .where("productId", "==", productId)
          .where("isReceive", "==", isReceive)
          .where("supplierId", "==", supplierId)
          .where("customerId", "==", customerId)
          .orderBy("issueDate", "desc")
          .limit(100),
    );
  }

  getProductInventoriesByReceipt(
    shopId: string,
    receiptId: string,
  ): AngularFirestoreCollection<ProductInventory> {
    return this.db.collection(
      this.dbPath + `/${shopId}/product-inventories`,
      (ref) =>
        ref
          .where("isDeleted", "==", false)
          .where("isActive", "==", true)
          .where("receiptId", "==", receiptId)
          .orderBy("issueDate", "asc"),
    );
  }

  getProductInventoriesByPurchase(
    shopId: string,
    purchaseId: string,
  ): AngularFirestoreCollection<ProductInventory> {
    return this.db.collection(
      this.dbPath + `/${shopId}/product-inventories`,
      (ref) =>
        ref
          .where("isDeleted", "==", false)
          .where("isActive", "==", true)
          .where("purchaseId", "==", purchaseId)
          .orderBy("issueDate", "asc"),
    );
  }

  get(shopId: string, id: string) {
    return this.db
      .collection(this.dbPath + `/${shopId}/product-inventories`)
      .doc(id)
      .valueChanges();
  }

  create(inventory: ProductInventory): any {
    let obj = _.clone(inventory);
    delete obj.id;

    obj.isReceive = obj.isReceive ? true : false;
    obj.issueDate = obj.issueDate ? new Date(obj.issueDate) : new Date();
    obj.issueDateYear = obj.issueDate.getFullYear();
    obj.issueDateMonth = obj.issueDate.getMonth() + 1;
    obj.issueDateDay = obj.issueDate.getDate();
    obj.issueDateWeekDay = obj.issueDate.getDay();
    obj.issueDateHours = obj.issueDate.getHours();
    obj.issueDateMinutes = obj.issueDate.getMinutes();
    obj.issueDateSeconds = obj.issueDate.getSeconds();

    obj.productCode = inventory.productCode || "";
    obj.productName = inventory.productName || "";
    obj.productUnitName = inventory.productUnitName || "";

    obj.isActive = true;
    obj.isDeleted = false;
    obj.createdOn = new Date();
    obj.createdBy = this.userLogin.uid;
    obj.updatedOn = new Date();
    obj.updatedBy = this.userLogin.uid;
    obj.author = this.userLogin;
    obj.visibility = this.visibility;
    obj.timestamp = new Date().getTime();

    obj.shopId = obj.shopId ? obj.shopId : this.userLogin.shopId;
    this.collRef = this.db.collection(
      this.dbPath + `/${inventory.shopId}/product-inventories`,
    );

    console.log("create inventory:", obj);

    return this.collRef.add({ ...obj }).then((docRef) => {
      inventory.id = docRef.id;
      return inventory;
    });
  }

  update(inventory: ProductInventory): Promise<void> {
    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;

    inventory.issueDate = inventory.issueDate
      ? inventory.issueDate
      : new Date();
    inventory.issueDateYear = inventory.issueDate.getFullYear();
    inventory.issueDateMonth = inventory.issueDate.getMonth() + 1;
    inventory.issueDateDay = inventory.issueDate.getDate();
    inventory.issueDateWeekDay = inventory.issueDate.getDay();
    inventory.issueDateHours = inventory.issueDate.getHours();
    inventory.issueDateMinutes = inventory.issueDate.getMinutes();
    inventory.issueDateSeconds = inventory.issueDate.getSeconds();

    this.collRef = this.db.collection(
      this.dbPath + `/${inventory.shopId}/product-inventories`,
    );

    console.log("update inventory:", inventory);
    return this.collRef.doc(inventory.id).update({
      issueDate: inventory.issueDate,
      issueDateSeconds: inventory.issueDateSeconds,
      issueDateMinutes: inventory.issueDateMinutes,
      issueDateHours: inventory.issueDateHours,
      issueDateDay: inventory.issueDateDay,
      issueDateWeekDay: inventory.issueDateWeekDay,
      issueDateMonth: inventory.issueDateMonth,
      issueDateYear: inventory.issueDateYear,
      code: inventory.code ? inventory.code : "",
      comment: inventory.comment ? inventory.comment : "",
      isReceive: inventory.isReceive,

      receivePrice: inventory.isReceive ? inventory.receivePrice : 0,
      receiveQuantity: inventory.isReceive ? inventory.receiveQuantity : 0,
      receiveAmount: inventory.isReceive ? inventory.receiveAmount : 0,

      issuePrice: !inventory.isReceive ? inventory.issuePrice : 0,
      issueQuantity: !inventory.isReceive ? inventory.issueQuantity : 0,
      issueAmount: !inventory.isReceive ? inventory.issueAmount : 0,

      productCode: inventory.productCode || "",
      productName: inventory.productName || "",
      productUnitName: inventory.productUnitName || "",

      updatedOn: updatedOn,
      updatedBy: updatedBy,
      timestamp: new Date().getTime(),
    });
  }

  updateInitInventory(
    shopId: string,
    inventoryId: string,
    receivePrice: number,
    receiveQuantity: number,
    receiveAmount: number,
  ): Promise<void> {
    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;

    this.collRef = this.db.collection(
      this.dbPath + `/${shopId}/product-inventories`,
    );
    return this.collRef.doc(inventoryId).update({
      receivePrice: receivePrice,
      receiveQuantity: receiveQuantity,
      receiveAmount: receiveAmount,
      updatedOn: updatedOn,
      updatedBy: updatedBy,
      timestamp: new Date().getTime(),
    });
  }

  delete(shopId: string, id: string): Promise<void> {
    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;

    this.collRef = this.db.collection(
      this.dbPath + `/${shopId}/product-inventories`,
    );

    return this.collRef.doc(id).update({
      isDeleted: true,
      updatedOn: updatedOn,
      updatedBy: updatedBy,
      timestamp: new Date().getTime(),
    });
  }
}
